import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=687937ca&scoped=true&"
import script from "./Settings.vue?vue&type=script&lang=ts&"
export * from "./Settings.vue?vue&type=script&lang=ts&"
import style0 from "./Settings.vue?vue&type=style&index=0&id=687937ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687937ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('687937ca')) {
      api.createRecord('687937ca', component.options)
    } else {
      api.reload('687937ca', component.options)
    }
    module.hot.accept("./Settings.vue?vue&type=template&id=687937ca&scoped=true&", function () {
      api.rerender('687937ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/settings/Settings.vue"
export default component.exports